/**
 * Numeric-aware string comparison
 * Handles sorting of strings that contain numbers correctly
 * Example: "Device 1", "Device 2", "Device 10" instead of "Device 1", "Device 10", "Device 2"
 */
export const numericLocaleCompare = (a: string, b: string): number => {
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
};

/**
 * Extract numeric value from string for sorting
 * Example: "Device 2" -> 2, "Device 19" -> 19
 */
export const extractNumericValue = (str: string): number => {
  const match = str.match(/\d+/);
  return match ? parseInt(match[0], 10) : 0;
};

/**
 * Numeric-aware sort comparator
 * First tries numeric comparison, then falls back to string comparison
 */
export const numericAwareSort = (a: string, b: string): number => {
  const numA = extractNumericValue(a);
  const numB = extractNumericValue(b);

  // If both have numeric values, compare numerically
  if (numA !== 0 && numB !== 0) {
    return numA - numB;
  }

  // Otherwise use locale compare with numeric option
  return numericLocaleCompare(a, b);
};
